import styled from 'styled-components'

const TimerStyle = styled.div.attrs()`
	background-color: var(--lightPurple);
	border-radius: 10px;
	width: var(--sp52x);
	padding: var(--sp4x);

	.timer {
        width:100%;

        .dot {
            margin:0 var(--sp2x);
        }

		.cont {
            .single-time {
                align-items:center;

                .block {
                    position: relative;
                    padding: 4px 8px;
                    background-color:var(--white) ;
                    border-radius:8px;
                    margin-bottom:var(--spSize);
                }

                .type {
                    color:#897D99;
                }
			}
		}
	}

    .debate-info {
        align-self:flex-start;
        margin-top:var(--sp3x);
        padding-top:var(--sp2x);
        margin-bottom:var(--sp3x);
        padding-bottom:var(--sp2x);
        border-top:1px solid #F0EAF6;
        border-bottom:1px solid #F0EAF6;
        width: 100%;
        
        .imageCont {
            width: 44px;
            padding-top:44px;
            border-radius:8px;
            margin-right:var(--sp2x);
            overflow: hidden;
        }
    }

    .buttons {
        width:100%;

        button {
            width: calc(50% - 8px);
            display: flex;
            justify-content:center;
            position: relative;
            background-color: var(--lightPurple);
            
            &.active {
                
                @media screen and (min-width:1200px){
                    color:var(--white);
                    background-color:var(--purple);

                    i,.i {
                        &:before {
                            color:var(--white);
                        }
                    }   

                    .share-popup {
                        opacity: 1;
                        pointer-events:all;
                    }
                }
            }

            i,.i {
                margin-right:8px;
                transition: var(--trTime);

                &:before {
                    color:var(--purple);
                }
            }

            .share-popup {
				position: absolute;
				bottom: calc(100% + var(--spSize));
				padding: 14px;
				border: 2px solid var(--purple);
				border-radius: 8px;
				background-color: var(--white);
				opacity: 0;
				transition: 0.3s;
				pointer-events:none;
                z-index:1;
				
                &.active {
					opacity: 1;
					pointer-events:all;
                }

                a {
                    &{
                        margin-right: var(--sp2x);
                    }

                    &:hover {
                        i {
                            transform: scale(1.1);
                        }
                    }

                    i {
                        transition: var(--trTime);
                        font-size:var(--sp3x);
                        display: block;
                        
                        &:before {
                            color:var(--purple);
                        }
                    }
                }

                span {
                    &:hover {
                        i {
                            transform: scale(1.1);
                        }
                    }

                    i {
                        transition: var(--trTime);
                        font-size:var(--sp3x);
                        display: block;
                        
                        &:before {
                            color:var(--purple);
                        }
                    }
                }
                
			}
        }
    }

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
        width: 100%;
	}
`

export default TimerStyle
